module.exports = __webpack_public_path__ + "img/nt.45882d3a.png";